import { SearchResultStatus } from './types';

export const getResultStatus = (
	errorMessage: string | null | undefined,
	resultCount: number,
): SearchResultStatus => {
	if (errorMessage) {
		return SearchResultStatus.Error;
	}
	if (resultCount > 0) {
		return SearchResultStatus.Results;
	}
	return SearchResultStatus.Empty;
};
